import { createContext } from 'react';

export const CityDataContext = createContext();